const mapItemToValues = (item: any) => {
  return ({
    ...item,
    waitForPayment: !!item.waitForPayment,
    absenceMail: !!item.absenceMail,
  })
}

const mapValuesForSubmit = (values: any) => {
  return ({
    ...values,
    waitForPayment: !!values.waitForPayment,
    absenceMail: !!values.absenceMail,
  })
}

const mapSubmitErrorsToForm = (submitErrors: any) => {
  let errorKeys = Object.keys(submitErrors);

  if (errorKeys.length === 0) {
    return [];
  }

  return errorKeys.map((key: any) => ({
    name: key,
    errors: submitErrors[key]
  }));
}
const exportedObject = {
  mapItemToValues, mapSubmitErrorsToForm, mapValuesForSubmit
};

export default exportedObject;
